import styles from './PreOrderNowModal.module.scss';
import { Modal, Button, Row, Col, Checkbox, Select, Input, Divider } from "antd";
import React, { useState } from 'react';



const PreOrderNowModal = ({ showModal, setShowModal }) => {
    const [step, setStep] = useState(1);

    return (
        <Modal
        open={showModal}
            closeIcon={<img height="25" src="/pre-book/order_modal_close.svg" alt="close" />}
            onCancel={() => setShowModal(false)}
            footer={null}
            width={700}
            centered
            title={
                <div className={styles.modal_title_logo}>
                    <img height="75" src="/pre-book/order_modal_logo.svg" alt="logo" />
                </div>
            }
            className="pre_order_modal"
        >
            {step === 1 ? (
                <div className={styles.register_interest_form_container}>
                    <div className={styles.register_interest_form_heading}>
                        <h4>Register your interest to Pre order Desi Fresh Products</h4>
                        <p>No charges until product arrives. First shipping will be available in from August 2022</p>
                    </div>
                    <div className={styles.register_interest_form_main}>
                        <Row style={{ marginBottom: 25 }}>
                            <Col span={24}>
                                <Select
                                    onChange={(value) => {
                                        console.log(value)
                                    }}
                                    style={{
                                        width: "100%",
                                    }}
                                    size="large"
                                    placeholder="What do you like to order for your household needs"
                                >
                                    <Select.Option value="1">Option 1</Select.Option>
                                    <Select.Option value="2">Option 2</Select.Option>
                                    <Select.Option value="3">Option 3</Select.Option>
                                </Select>
                            </Col>
                        </Row>

                        <h3 style={{ marginBottom: 15 }}> 1. Your basic information: </h3>

                        <Row gutter={[20, 20]}>
                            <Col span={4}>
                                <Select
                                    defaultValue="1"
                                    onChange={(value) => {
                                        console.log(value)
                                    }}
                                    style={{
                                        width: "100%",
                                    }}
                                    size="large"
                                >
                                    <Select.Option value="1">Mr.</Select.Option>
                                    <Select.Option value="2">Ms.</Select.Option>
                                </Select>
                            </Col>
                            <Col span={10}>
                                <Input size="large" placeholder="First name" />
                            </Col>
                            <Col span={10}>
                                <Input size="large" placeholder="Last name" />
                            </Col>
                            <Col span={24}>
                                <Input size="large" placeholder="E-mail Address" />
                            </Col>
                            <Col span={24}>
                                <Input.TextArea size="large" autoSize placeholder="Address" />
                            </Col>

                            <Col span={12}>
                                <Input size="large" placeholder="City" />
                            </Col>
                            <Col span={12}>
                                <Input size="large" placeholder="House No." />
                            </Col>

                            <Col span={12}>
                                <Input size="large" placeholder="Zip code" />
                            </Col>

                            <Col span={24} className={styles.checkbox}>
                                <Checkbox onChange={(e) => {
                                    console.log(e.target.checked);
                                }} />
                                <h5>Yes, I would like to subscribe for pre order and updates by e-amil and agree to the processing of my personal data in accordance with the Desi Fresh <span>Data Protection Policy</span> . You can <span>unsubscribe</span>  anytime you wish to not recieve any information about products and promotions of Desi Fresh.
                                    For more information, please see our <span>privacy policy</span>
                                </h5>
                            </Col>
                        </Row>

                        <div className={styles.submit_btn_wrapper}>
                            <Button
                                onClick={() => { setStep(2) }}
                                type="primary"
                                className={styles.submit_btn}
                                size="large"
                            >
                                Pre book now
                            </Button>
                        </div>

                    </div>
                </div>
            ) : (
                <div className={styles.register_interest_success}>
                    <img height='80' src="/pre-book/fireworks.svg" alt="fireworks" />

                    <h5>Thank you for interest  to pre order our products. You will be among the first to receive our products. Will be back to you soon!
                    </h5>

                    <img height='40' src="/pre-book/mail.svg" alt="mail" />

                    <Input
                        value={""}
                        suffix={
                            <img height="25" src="/pre-book/copy.svg" alt="copy" />
                        }
                        style={{ cursor: "pointer" }}
                        size="large"
                    />

                    <h5 className={styles.spread_love}>Spread the word your loved ones</h5>

                    <Button type="primary" size="large" className={styles.share_btn}>
                        <span>Share or invite</span>
                        <img src="/pre-book/share_icon.svg" height="16" alt="share" />
                    </Button>

                    <h5 style={{ color: "#7C7C7C" }}>You can also follow us here for updates.</h5>

                    <Divider style={{ margin: 0 }} />

                    <div className={styles.share_icons_wrapper}>
                        <a href="http://facebook.com" target="_blank" rel="noopener noreferrer">
                            <img height="30" src="/pre-book/wp_icon.svg" alt="fb_icon" />
                        </a>

                        <a href="http://facebook.com" target="_blank" rel="noopener noreferrer">
                            <img height="30" src="/pre-book/tiktok_icon.svg" alt="tiktok_icon" />
                        </a>

                        <a href="http://facebook.com" target="_blank" rel="noopener noreferrer">
                            <img height="30" src="/pre-book/twitch_icon.svg" alt="twitch_icon" />
                        </a>

                        <a href="http://facebook.com" target="_blank" rel="noopener noreferrer">
                            <img height="30" src="/pre-book/twitter_icon.svg" alt="twitter_icon" />
                        </a>

                        <a href="http://facebook.com" target="_blank" rel="noopener noreferrer">
                            <img height="30" src="/pre-book/youtube_icon.svg" alt="youtube_icon" />
                        </a>

                        <a href="http://facebook.com" target="_blank" rel="noopener noreferrer">
                            <img height="30" src="/pre-book/fb_icon.svg" alt="fb_icon" />
                        </a>

                        <a href="http://facebook.com" target="_blank" rel="noopener noreferrer">
                            <img height="30" src="/pre-book/insta_icon.svg" alt="insta_icon" />
                        </a>

                        <a href="http://facebook.com" target="_blank" rel="noopener noreferrer">
                            <img height="30" src="/pre-book/linkedin_icon.svg" alt="linkedin_icon" />
                        </a>
                    </div>
                </div>
            )}
        </Modal>
    );
}

export default PreOrderNowModal;